import React, { forwardRef } from 'react'

import { IconProps } from './types'

const NumberIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ size, stroke, color, strokeWidth, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 5L7 2H6L5.5 5H2.67004L2.5 6H5.33333L4.66667 10H1.92004L1.75 11H4.5L4 14H5L5.5 11H9.5L9 14H10L10.5 11H13.5L13.67 10H10.6667L11.3333 6H14L14.17 5H11.5L12 2H11L10.5 5H6.5ZM9.66667 10L10.3333 6H6.33333L5.66667 10H9.66667Z"
        fill={color || 'currentColor'}
        stroke={stroke || 'currentColor'}
        strokeWidth={strokeWidth || 0.5}
      />
    </svg>
  ),
)
NumberIcon.displayName = 'NumberIcon'

export default NumberIcon
